class TitleConstants {
  App = "Inkfree";
  Separator = " | ";

  FormattedTitleEnd = this.Separator + this.App;

  LOGIN = "Login" + this.FormattedTitleEnd;
  FORGOT_PASSWORD = "Forgot Password" + this.FormattedTitleEnd;
  RESET_PASSWORD = "Reset Password" + this.FormattedTitleEnd;
  VERITY_OTP = "Verify OTP" + this.FormattedTitleEnd;
  SETUP_MFA = "Setup MFA" + this.FormattedTitleEnd;
  REGISTER = "Register" + this.FormattedTitleEnd;
  CHECK_YOUR_EMAIL = "Check your email" + this.FormattedTitleEnd;
  VERIFY_PASSWORD = "Verify Password" + this.FormattedTitleEnd;
  PASSWORD_EXPIRED = "Password Expired" + this.FormattedTitleEnd;
  MCP_AUTHORIZE = "Connect to Inkfree" + this.FormattedTitleEnd;
  AWS_MARKETPLACE_SETUP = "Set up your AWS Marketplace subscription" + this.FormattedTitleEnd;
  OAUTH_CONSENT = "Authorize Access" + this.FormattedTitleEnd;

  SETTINGS = "Settings" + this.FormattedTitleEnd;
  GENERAL = "General" + this.FormattedTitleEnd;
  USERS = "Users" + this.FormattedTitleEnd;
  ROLE_MANAGEMENT = "Role Management" + this.FormattedTitleEnd;
  SECURITY = "Security" + this.FormattedTitleEnd;
  SECURITY_POLICIES = "Security Policies" + this.FormattedTitleEnd;
  ENTERPRISE_SSO = "Enterprise SSO" + this.FormattedTitleEnd;
  PREFERENCES = "Preferences" + this.FormattedTitleEnd;
  TEAM = "Team" + this.FormattedTitleEnd;
  PROFILE = "Profile" + this.FormattedTitleEnd;
  BRANDING = "Branding" + this.FormattedTitleEnd;
  PLAN = "My Plan" + this.FormattedTitleEnd;

  DASHBOARD = "Dashboard" + this.FormattedTitleEnd;
  CONTACTS = "Contacts" + this.FormattedTitleEnd;
  TICKETS = "Tickets" + this.FormattedTitleEnd;
  TEMPLATES = "Templates" + this.FormattedTitleEnd;
  BULK_SEND = "Bulk Send" + this.FormattedTitleEnd;
  BULK_BATCH = "Batch" + this.FormattedTitleEnd;
  BULK_QUEUE = "Signing Queue" + this.FormattedTitleEnd;
  WEBFORMS = "Web Forms" + this.FormattedTitleEnd
  WEBFORM_AI = "Build with AI" + this.FormattedTitleEnd;
  SIGN_REQUEST = "Sign Request" + this.FormattedTitleEnd;
  DECLINE_REQUEST = "Decline Request" + this.FormattedTitleEnd;
  IN_PERSON_HOST = "In-Person Signing" + this.FormattedTitleEnd;
  LINK_EXPIRED = "Link Expired" + this.FormattedTitleEnd;
  INBOX = "Inbox" + this.FormattedTitleEnd;
  SENT = "Sent" + this.FormattedTitleEnd;
  CONFIGURATION = "Configuration" + this.FormattedTitleEnd;
  DOCUMENT_SETTINGS = "Document Settings" + this.FormattedTitleEnd;
  DELEGATION = "Delegation" + this.FormattedTitleEnd;
  RENEWABLE_DOCUMENTS = "Renewable Documents" + this.FormattedTitleEnd;
  RENEWABLE_DOCUMENTS_LIST =
    "Renewable Documents List" + this.FormattedTitleEnd;
  INSIGHTS = "Insights" + this.FormattedTitleEnd;
  CONTRACT_SEARCH = "Contract Search" + this.FormattedTitleEnd;
  ANALYTICS = "Analytics" + this.FormattedTitleEnd;
  DOCUMENT_PROGRESS = "Document Progress" + this.FormattedTitleEnd;
  INTEGRATIONS = "Integrations" + this.FormattedTitleEnd;
  PAGE_NOT_FOUND = "Page Not Found" + this.FormattedTitleEnd;
  CLOUD_STORAGE_CONNECT = "Connecting" + this.FormattedTitleEnd;

  addPrefixToTitle = (prefix: string, suffix: string) => {
    if (!prefix) {
      return suffix;
    }
    return prefix + this.Separator + suffix;
  };
}

let title = new TitleConstants();
export default title;
